import moment from 'moment';
import { map } from 'lodash';
import { IDropdownOption } from '@fluentui/react';
import { TFunction } from 'i18next';

/** Possible types of date selector control */
export enum DateSelectorType {
  'updatetuesday' = 'updatetuesday',
  'date' = 'date',
  'month' = 'month',
  'today' = 'today',
}

export enum DateRangeEnd {
  start = 'start',
  end = 'end',
}

export const monthList = (): IDropdownOption[] =>
  map(moment.monthsShort(), (m, i) => ({
    key: i,
    value: i,
    text: moment(i + 1, 'M').format('MMMM'),
  }));

export const useDayPickerStrings = (t: TFunction) => {
  return {
    months: moment.months(),
    shortMonths: moment.monthsShort(),
    days: moment.weekdays(),
    shortDays: moment.weekdaysMin(),
    goToToday: t('search:datePickerGoToToday', 'Go to today'),
    prevMonthAriaLabel: 'Go to previous month',
    nextMonthAriaLabel: 'Go to next month',
    prevYearAriaLabel: 'Go to previous year',
    nextYearAriaLabel: 'Go to next year',
    closeButtonAriaLabel: t('Close', {
      defaultValue: 'Close',
      ns: 'translation',
    }),
  };
};
